// Email Confirmation Status Modal
// Parses URL parameters and shows a Bootstrap-styled modal indicating
// whether email confirmation succeeded or failed.

(function () {
  function parseStatus() {
    const url = new URL(window.location.href);
    const p = url.searchParams;

    // Preferred explicit flag we set in redirectTo (check both URL and sessionStorage)
    let explicit = p.get('email-confirmation'); // 'success' | 'failed'
    if (!explicit) {
      try {
        explicit = sessionStorage.getItem('auth:email_confirmation');
        if (explicit) sessionStorage.removeItem('auth:email_confirmation');
      } catch (_) {}
    }

    // Supabase may append error indicators on failure
    const sbError = p.get('error') || p.get('error_code') || p.get('error_description');

    // If explicit is set, start with it; otherwise infer from Supabase params
    let status = explicit ? explicit.toLowerCase() : null;

    // If Supabase indicates an error, treat as failure regardless of explicit flag
    if (sbError) status = 'failed';

    // Only show modal when we have a status
    return status; // 'success' | 'failed' | null
  }

  function trackEmailConfirmation(status) {
    try {
      if (!window.gtag) return;
      const isSuccess = status === 'success';
      const params = {
        method: 'email',
        status: isSuccess ? 'success' : 'failed',
        surface: 'VR'
      };
      window.gtag('event', 'email_confirmation', params);
      window.gtag('event', `VR_TopNav_Account_EmailConfirmation${isSuccess ? 'Success' : 'Failed'}`, params);
    } catch (_) {}
  }

  function showModal(status) {
    const isSuccess = status === 'success';
    const textToShow = isSuccess ? 'Your email address has been confirmed successfully' : 'We were unable to confirm your email address.';
    if (window.AuthUI && window.AuthUI.showMessage) {
      window.AuthUI.showMessage(textToShow, !isSuccess);
    }
    
  }

  function ready(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(fn, 0);
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    const status = parseStatus();
    if (!status) return;
    trackEmailConfirmation(status);
    showModal(status);
  });
})();
